<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('CargoMsg.ChargeMappingFuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid" style="flex-grow: 1;">
      <cargo-ag-grid
        no="grid"
        config-module="101375"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        config-module="101375"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form id="editForm" label-width="110px" label-position="left">
          <el-form-item class="controlWidth" :label="$t('CargoMsg.AllowSaleProduct')" required>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_AllowSaleProduct"
              filterable
              no="allowSaleProduct"
              clearable
              :default-value="editDialog.form.saleProductCode || ''"
              @parentCallBack="p => {
                editDialog.form.saleProductCode = p.value
              }"
            />
          </el-form-item>
          <el-form-item class="controlWidth" :label="$t('CargoMsg.FullOrInside')" required>
            <cargo-advance-select
              :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
              no="fullOrInside"
              clearable
              :default-value="editDialog.form.fullOrInside || ''"
              @parentCallBack="p => {editDialog.form.fullOrInside = p.value}"
            />
          </el-form-item>
          <el-form-item class="controlWidth" :label="$t('CargoMsg.Cargo_TaxRate')" required>
            <el-input v-model="editDialog.form.taxRate" clearable no="taxRate" @input="handleInput" @blur="handleBlur" />
          </el-form-item>
          <el-form-item class="controlWidth" :label="$t('CargoMsg.Cargo_ChargeName')" required>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_ChargeItem"
              no="chargeItemId"
              filterable
              clearable
              :default-value="editDialog.form.chargeItemId"
              @parentCallBack="p => {editDialog.form.chargeItemId = p.value}"
            />
          </el-form-item>
          <el-form-item class="controlWidth" :label="$t('CargoMsg.TransmitChargeName')" required>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_ChargeGroup"
              no="transmitChargeName"
              filterable
              clearable
              tag-value="code"
              :default-value="editDialog.form.transmitChargeCode"
              @parentCallBack="p => {
                editDialog.form.transmitChargeCode = p.code
              }"
            />
          </el-form-item>
          <el-form-item class="controlWidth" :label="$t('CargoMsg.TransmitChargeCode')">
            <el-input v-model="editDialog.form.transmitChargeCode" :disabled="true" no="transmitChargeCode" />
          </el-form-item>
          <el-form-item class="controlWidth" :label="$t('CargoMsg.MaintainerRemarks')">
            <el-input v-model="editDialog.form.remark" :rows="4" type="textarea" no="remark" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getChargeMappingList, saveChargeMapping, delChargeMapping } from '@/api/sysManage/baseConfig/ChargeMapping'
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import ColumnUtils from '@/utils/ColumnUtils'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'ChargeMapping',
  components: { CargoAdvanceSelect },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        },
        onRowClicked: event => {
          this.onRowClicked(event)
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.AllowSaleProduct'),
          field: 'saleProductCode',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AllowSaleProduct, 'productCode', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.FullOrInside'),
          field: 'fullOrInside',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveFullOrInside(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TaxRate'),
          field: 'taxRate',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeName'),
          field: 'chargeItemId',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('CargoMsg.TransmitChargeName'),
          field: 'transmitChargeCode2',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeGroup, 'code', params.data.transmitChargeCode, 'name')
          }
        },
        {
          headerName: this.$t('CargoMsg.TransmitChargeCode'),
          field: 'transmitChargeCode',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.MaintainerRemarks'),
          field: 'remark',
          width: 200
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          fullOrInside: '',
          taxRate: '',
          chargeItemId: '',
          transmitChargeCode: '',
          remark: '',
          chargeGroupUuid: '',
          saleProductCode: ''
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    // 税率只允许输入整数或小数
    handleInput(value) {
      const reg = /^[0-9]*\.?[0-9]*$/
      if (!reg.test(value)) {
        this.editDialog.form.taxRate = value.replace(/[^0-9.]/g, '')
        // 进一步检查是否有多个小数点
        const parts = this.editDialog.form.taxRate.split('.')
        if (parts.length > 2) {
          this.editDialog.form.taxRate = parts[0] + '.' + parts.slice(1).join('')
        }
      }
    },
    handleBlur() {
      if (this.editDialog.form.taxRate) {
        // 将税率四舍五入到两位小数
        this.editDialog.form.taxRate = parseFloat(this.editDialog.form.taxRate).toFixed(2)
      }
    },
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      this.filter.likeName = this.filter.likeName.trim()
      getChargeMappingList(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          fullOrInside: '',
          taxRate: '',
          chargeItemId: '',
          transmitChargeCode: '',
          remark: '',
          chargeGroupUuid: '',
          saleProductCode: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (rows.length !== 1) {
          this.$message.warning(this.$t('common.tips.hasOneOnly'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo')
      }
      this.editDialog.visible = true
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.saleProductCode) {
        self.$message.warning(self.$t('CargoMsg.AllowSaleProductNotNull'))
        return
      }
      if (!form.fullOrInside) {
        self.$message.warning(self.$t('CargoMsg.FullOrInsideNotNull'))
        return
      }
      if (!form.taxRate) {
        self.$message.warning(self.$t('CargoMsg.Cargo_TaxRateNotNull'))
        return
      }
      if (!form.chargeItemId) {
        self.$message.warning(self.$t('CargoMsg.Cargo_ExpenseDescriptionCanTBeEmpty'))
        return
      }
      if (!form.transmitChargeCode) {
        self.$message.warning(self.$t('CargoMsg.TransmitChargeNameNotNull'))
        return
      }
      this.loading = getLoading()
      saveChargeMapping(form).then(() => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.editDialog.visible = false
        syncSpecificBasicData(basicCacheKeys.basic_data_ChargeMapping)
        self.$message.success(self.$t('common.tips.saveSuccess'))
        self.toQuery()
      }).catch(() => {
        // self.editDialog.visible = false
      }).finally(() => {
        this.loading.close()
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        self.syncRemove(rows, 0)
      }).catch(() => {
      })
    },
    syncRemove(rows, index) {
      const self = this
      if (index < rows.length) {
        delChargeMapping(rows[index].uuid).then(() => {
          self.syncRemove(rows, index + 1)
        }).catch(() => {
          if (index > 0) {
            self.filter.pageNum = 1
            self.toQuery()
          }
        })
      } else {
        self.filter.pageNum = 1
        self.$message.success(self.$t('common.tips.deleteSuccess'))
        self.toQuery()
      }
    }

  }
}
</script>

<style lang="scss" scoped>
#editForm{
  .controlWidth{
    width: 280px;
  }
}
</style>
